import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import React from "react";

interface EntityBulkActionsProps {
  selectedCount: number;
  onEnable: () => void;
  onDisable: () => void;
  onDelete: () => void;
}

export const EntityBulkActions: React.FC<EntityBulkActionsProps> = ({
  selectedCount,
  onEnable,
  onDisable,
  onDelete
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        backgroundColor: "primary.50",
        borderColor: "primary.200",
        borderWidth: 1,
        borderStyle: "solid"
      }}
      variant="outlined"
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body2" color="primary.main">
          {selectedCount} {selectedCount === 1 ? "person" : "people"} selected
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button size="small" variant="outlined" onClick={onEnable}>
            Enable
          </Button>
          <Button size="small" variant="outlined" onClick={onDisable}>
            Disable
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={onDelete}
          >
            Delete
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
};
